const features = [
  {
    id: 1,
    icon: 'ri-flashlight-fill',
    title: '极速更新',
    desc: '7×24小时实时追踪全网黑料热点，重大爆料30分钟内上线，确保您第一时间吃瓜。',
  },
  {
    id: 2,
    icon: 'ri-database-2-line',
    title: '海量内容',
    desc: '每日更新200+条黑料吃瓜内容，涵盖娱乐圈、网红圈、社会热点等多领域瓜田爆料与黑料视频。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '全面支持电脑、手机、平板等设备访问，无需下载APP，五一黑料入口随时可用。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '隐私保护',
    desc: '严格保护爆料人隐私与用户信息安全，采用加密传输，让您放心吃瓜无后顾之忧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          平台优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="text-center p-6 md:p-7 bg-background-100 border border-secondary-200/60 rounded-xl hover:border-primary-200/60 transition-colors cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}